<div class="dashboard">

  <div class="card">
    <div class="card__header">My Assigned Courses</div>
    <div class="card__content">
      <div class="muted" *ngIf="loading()">Loading…</div>
      <div class="error" *ngIf="errorText()">
        {{ errorText() }}
        <button type="button" class="error__close" (click)="dismissError()">×</button>
      </div>
      <ng-container *ngIf="!loading()">
        <div class="muted" *ngIf="assigned().length === 0">No courses available.</div>
        <div class="accordion" *ngIf="assigned().length > 0">
          <div class="accordion-item"
               *ngFor="let c of assigned()"
               [ngClass]="{
                'status-assigned': c.STATUS === STATUS.ASSIGNED,
                'status-inprogress': c.STATUS === STATUS.IN_PROGRESS,
                'status-completed': c.STATUS === STATUS.COMPLETED
               }">
            <button type="button"
                    class="accordion-header"
                    (click)="toggleExpand(c.COURSE_ID)"
                    [aria-expanded]="isActive(c.COURSE_ID)">
              <span class="acc-arrow" [class.expanded]="isActive(c.COURSE_ID)"></span>
              <span class="acc-title">{{ getCourseName(c.COURSE_ID) }}</span>
              <span class="badge"
                    [ngClass]="{
                      'badge--blue': c.STATUS === STATUS.ASSIGNED,
                      'badge--orange': c.STATUS === STATUS.IN_PROGRESS,
                      'badge--green': c.STATUS === STATUS.COMPLETED
                    }">{{ statusLabel(c.STATUS) }}</span>
            </button>
            <div class="accordion-panel" *ngIf="isActive(c.COURSE_ID)">
              <div class="panel-toolbar" *ngIf="buttonsVisible(c.STATUS)">
                <button *ngIf="showMarkInProgress(c.STATUS)"
                        type="button"
                        class="btn btn--sm btn--outline"
                        [disabled]="!canMark(c.COURSE_ID, 'IN_PROGRESS', c.STATUS)"
                        (click)="markStatus(c.COURSE_ID, 'IN_PROGRESS')">
                  Mark In Progress
                </button>
                <button *ngIf="showMarkCompleted(c.STATUS)"
                        type="button"
                        class="btn btn--sm btn--success"
                        [disabled]="!canMark(c.COURSE_ID, 'COMPLETED', c.STATUS)"
                        (click)="markStatus(c.COURSE_ID, 'COMPLETED')">
                  Mark Completed
                </button>
              </div>
              <div class="status" *ngIf="detailsMap().get(c.COURSE_ID)?.loading">Loading…</div>
              <ng-container *ngIf="!detailsMap().get(c.COURSE_ID)?.loading">
                <div *ngIf="detailsMap().get(c.COURSE_ID)?.course as course">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Type</th>
                        <th>Key</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of course.CONTENT">
                      <td>{{ item.SNO }}</td>
                        <td>{{ item.CONTENT_TYPE }}</td>
                        <td>
                          <ng-container [ngSwitch]="item.CONTENT_TYPE">
                            <ng-container *ngSwitchCase="'VIDEO'">
                              <ng-container *ngIf="videoExists(item.KEY); else missingVideo">
                                <a [href]="videoUrl(c.COURSE_ID, item.KEY) || '#'"
                                   (click)="onVideoClick(c.COURSE_ID, item.KEY, $event)"
                                   target="_blank" rel="noopener">
                                  {{ item.KEY }}
                                </a>
                              </ng-container>
                              <ng-template #missingVideo>
                                <em>{{ item.KEY }} (video no longer exists)</em>
                              </ng-template>
                            </ng-container>
                            <a *ngSwitchCase="'DOCUMENT'"
                               [href]="item.KEY"
                               target="_blank" rel="noopener">
                              {{ item.KEY }}
                            </a>
                            <span *ngSwitchDefault>{{ item.KEY }}</span>
                          </ng-container>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>


